import { ReactNode } from 'react';
import { Chip, Tooltip } from '@nimbus-ds/components';

interface ChipWithTooltipProps {
  id: string;
  label: string;
  removable?: boolean;
  onClick: (id: string) => void;
  icon?: ReactNode;
  tooltipContent?: string;
}

function ChipWithTooltip({
  id,
  label,
  removable,
  onClick,
  icon,
  tooltipContent,
}: Readonly<ChipWithTooltipProps>) {
  const chipElement = (
    <Chip
      id={id}
      text={label}
      removable={removable}
      onClick={() => onClick(id)}
      icon={icon}
    />
  );
  return tooltipContent ? (
    <Tooltip position="top" arrow content={tooltipContent}>
      {chipElement}
    </Tooltip>
  ) : (
    chipElement
  );
}

export default ChipWithTooltip;
